import {
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip
} from "@material-ui/core";
import moment from "moment";
import { handleKeyDown } from "../../common/common";
import { fuelPriceOptions } from "../../constants";
import { fmt3 } from "../../utils";

function BunkerSupplyMarginAllowance(props) {
    const {
        portOperation = [],
        onChangeBunkerScrubber = () => { },
        selectedVessels = {},
        onChangeSyncBunker = () => { },
        clientQuery = () => { },
        onChangePortOperations = () => { },
        disableEdit = false,
        syncBunker = false,
        calculatorData = {},
        setCalculatorData = () => { },
        onChangeClientQuery = () => { },
    } = props;

    const { fuelType = "" } = clientQuery || {};

    let selectedFuelType = fuelPriceOptions.find(
        (item) => item.value === fuelType,
    );
    if (selectedFuelType) selectedFuelType = selectedFuelType.label;
    else selectedFuelType = "Type-1";

    const onChangeMarginAllowance = (e, index) => {
        const { name = "", value = "" } = e.target;
        let updatedPortOperation = [...portOperation];
        if (name === "dwf") {
            updatedPortOperation[index].dwf = Number(value);
        } else {
            updatedPortOperation[index].cargoDetails[name] = Number(value);
        }
        setCalculatorData({
            ...calculatorData,
            portOperation: updatedPortOperation,
        });
    };

    const SHORT_HEADERS = {
        "Speed Factor (%)": "Speed F.",
        "Speed Reduce (Knots)": "Spd Red.",
        "Banker Factor (%)": "Bank F.",
        "Arrival Bunkers": "Arrival",
        "Bunker Supplied at port": "Supplied",
        "Selected Fuel Type": "Fuel",
    };

    function trimHeader(header) {
        return SHORT_HEADERS[header] || header;
    }

    const getColumnWidth = (id) => {
        switch (id) {
            case "Operation":
            case "Port":
                return { width: 70, minWidth: 70, maxWidth: 75 };
            case "arrivalTime":
            case "departureTime":
                return {
                    width: 100,
                    minWidth: 100,
                    maxWidth: 120,
                };
            case "dwf":
            case "speedFactor":
            case "speedReduce":
            case "bnkrFactor":
                return { width: 54, minWidth: 54, maxWidth: 55 };
            case "Paid By":
            case "Reserve":
                return {
                    width: 60,
                    minWidth: 60,
                    maxWidth: 65,
                };
            default:
                return { width: 50, minWidth: 42, maxWidth: 75 };
        }
    };

    const commanStyles = {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        height: "100%",
        minHeight: "17px",
        margin: 0,
        padding: "0 4px",
        boxSizing: "border-box",
        fontWeight: 300,
        fontSize: "11px",
        color: "#000000",
        WebkitTextFillColor: "#000000",
        opacity: 1,
    };

    return (
        <Grid container className="bunker-ui-container">
            {/* --- THEME OVERRIDES --- */}
            <style>{`
                .bunker-ui-container,
                .bunker-ui-container *,
                .compact-bunker-table,
                .compact-bunker-table *,
                .compact-bunker-table tr,
                .compact-bunker-table th,
                .compact-bunker-table td,
                .compact-bunker-table span,
                .compact-bunker-table div,
                .compact-bunker-table input,
                .compact-bunker-table select,
                .compact-bunker-table label,
                .compact-bunker-table p,
                .compact-bunker-table .MuiTableCell-root,
                .compact-bunker-table .MuiTableCell-head,
                .compact-bunker-table .MuiTableCell-body {
                    font-weight: 300 !important;
                    font-size: 11px !important;
                    color: #000000 !important;
                    -webkit-text-fill-color: #000000 !important;
                    opacity: 1 !important;
                    font-family: inherit;
                    -webkit-font-smoothing: antialiased !important;
                    -moz-osx-font-smoothing: grayscale !important;
                }
                
                /* TOP CONTROLS */
                .bunker-controls {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 6px;
                    font-size: 11px;
                }
                .bunker-controls input {
                    border: 1px solid #a3b8cb;
                    height: 18px;
                    padding: 0 4px;
                    font-size: 11px;
                    font-weight: 300 !important;
                    color: #000000 !important;
                    -webkit-text-fill-color: #000000 !important;
                    opacity: 1 !important;
                    border-radius: 2px;
                    outline: none;
                }
                .bunker-controls input:focus {
                    outline: 1.5px solid #d97706 !important;
                    outline-offset: -1.5px !important;
                    background-color: #ffffff !important;
                }

                /* TABLE CONTAINER */
                .compact-bunker-table {
                    border-radius: 0px;
                    box-shadow: none !important;
                    border: 1px solid #cbd5e1 !important;
                }
                .compact-bunker-table .MuiTable-root {
                    border-collapse: collapse;
                    table-layout: fixed;
                }

                /* HEADER STYLES - LEFT ALIGNED, NO BOLDNESS, BLACK TEXT */
                .compact-bunker-table .MuiTableHead-root .MuiTableRow-root {
                    height: 18px !important;
                    background-color: #e2e8f0 !important;
                }
                .compact-bunker-table .MuiTableHead-root .MuiTableCell-root {
                    background-color: #e2e8f0 !important;
                    color: #000000 !important;
                    -webkit-text-fill-color: #000000 !important;
                    opacity: 1 !important;
                    font-size: 11px !important;
                    font-weight: 300 !important;
                    padding: 0px !important;
                    border: 1px solid #cbd5e1 !important;
                    line-height: 18px !important;
                    height: 18px !important;
                    box-sizing: border-box !important;
                    text-transform: none !important;
                    text-align: left !important;
                }

                /* BODY STYLES - LEFT ALIGNED, NO BOLDNESS, BLACK TEXT */
                .compact-bunker-table .MuiTableBody-root .MuiTableRow-root {
                    height: 17px !important;
                    background-color: #ffffff !important;
                }
                .compact-bunker-table .MuiTableBody-root .MuiTableRow-root:nth-child(even) {
                    background-color: #f8fafc !important;
                }
                .compact-bunker-table .MuiTableBody-root .MuiTableCell-root {
                    border: 1px solid #cbd5e1 !important;
                    padding: 0px !important;
                    font-size: 11px !important;
                    font-weight: 300 !important;
                    color: #000000 !important;
                    -webkit-text-fill-color: #000000 !important;
                    opacity: 1 !important;
                    height: 17px !important;
                    line-height: 17px !important;
                    box-sizing: border-box !important;
                    text-align: left !important;
                }

                /* INPUTS & SELECTS - YELLOW ONLY IF EDITABLE, FOCUS UI, LEFT ALIGNED */
                .bunker-input,
                .bunker-select {
                    display: block;
                    width: 100%;
                    height: 17px !important;
                    line-height: 17px !important;
                    background-color: transparent;
                    border: none !important; 
                    border-radius: 0px;
                    outline: none;
                    font-size: 11px !important;
                    font-weight: 300 !important;
                    font-family: inherit;
                    color: #000000 !important;
                    -webkit-text-fill-color: #000000 !important;
                    opacity: 1 !important;
                    padding: 0 4px;
                    margin: 0;
                    box-sizing: border-box;
                    text-align: left !important;
                    -webkit-font-smoothing: antialiased !important;
                }

                /* ONLY EDITABLE INPUTS ARE YELLOW */
                .bunker-input:not(:disabled),
                .bunker-select:not(:disabled) {
                    background-color: #ffffd6 !important;
                }

                /* FOCUS UI FOR EDITABLE INPUTS - MATCHES SECOND IMAGE (#d97706 OUTLINE, WHITE BG) */
                .bunker-input:not(:disabled):focus,
                .bunker-select:not(:disabled):focus {
                    background-color: #ffffff !important;
                    outline: 1.5px solid #d97706 !important;
                    outline-offset: -1.5px !important;
                    box-shadow: none !important;
                }

                .compact-bunker-table .MuiTableCell-root:has(input:focus),
                .compact-bunker-table .MuiTableCell-root:has(select:focus) {
                    background-color: #ffffff !important;
                }

                /* DISABLED / NON-EDITABLE INPUTS */
                .bunker-input:disabled,
                .bunker-select:disabled {
                    background-color: transparent !important;
                    color: #000000 !important;
                    -webkit-text-fill-color: #000000 !important;
                    opacity: 1 !important;
                    font-weight: 300 !important;
                    cursor: default;
                }

                .bunker-select {
                    appearance: none;
                    cursor: pointer;
                    padding-right: 14px;
                    text-align: left !important;
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 5'%3E%3Cpath fill='%23000' d='M0 0l5 5 5-5z'/%3E%3C/svg%3E");
                    background-repeat: no-repeat;
                    background-position: right 2px center;
                    background-size: 6px 4px;
                }
                .bunker-select:disabled {
                    background-image: none;
                }

                /* Hide number arrows */
                .bunker-input::-webkit-outer-spin-button,
                .bunker-input::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
                .bunker-input[type=number] {
                    -moz-appearance: textfield;
                }
            `}</style>

            {/* STAGE 1: CONTROLS (Moved to SingleVesselCalcy) */}

            {/* STAGE 2: TABLE */}
            <Grid item xs={12}>
                <TableContainer component={Paper} className="compact-bunker-table">
                    <Table size="small">
                        <colgroup>
                            {[
                                "Operation", "Port", "Dwf (%)", "Speed Factor (%)", "Speed Reduce (Knots)",
                                "Banker Factor (%)", "Arrival", "Main", "ECA", "MGO", "Main", "ECA", "MGO",
                                "Total", "Reserve", "Paid By", "Main", "ECA", "MGO", "Departure",
                            ].map((header, idx) => {
                                const colId = idx === 6 ? "arrivalTime" : idx === 19 ? "departureTime" : header;
                                const widthStyles = getColumnWidth(colId);
                                return (
                                    <col
                                        key={idx}
                                        style={{ width: widthStyles.width || widthStyles.minWidth || 50 }}
                                    />
                                );
                            })}
                        </colgroup>

                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={6} style={{ borderBottom: "none" }} />
                                <TableCell colSpan={4}>
                                    <span style={commanStyles}>Arrival Bunkers</span>
                                </TableCell>
                                <TableCell colSpan={4}>
                                    <span style={commanStyles}>Bunker Supplied at port</span>
                                </TableCell>
                                <TableCell colSpan={2} style={{ borderBottom: "none" }} />
                                <TableCell colSpan={4}>
                                    <span style={commanStyles}>
                                        {trimHeader("Selected Fuel Type")}: {selectedFuelType}
                                    </span>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                {[
                                    "Operation", "Port", "Dwf (%)", "Speed Factor (%)", "Speed Reduce (Knots)",
                                    "Banker Factor (%)", "Arrival", "Main", "ECA", "MGO", "Main", "ECA", "MGO",
                                    "Total", "Reserve", "Paid By", "Main", "ECA", "MGO", "Departure",
                                ].map((header, idx) => {
                                    const shortHeader = trimHeader(header);
                                    const needsTooltip = shortHeader !== header;

                                    return (
                                        <TableCell key={header + idx}>
                                            {needsTooltip ? (
                                                <Tooltip title={<span className="text-xs">{header}</span>} placement="top">
                                                    <span style={commanStyles}>{shortHeader}</span>
                                                </Tooltip>
                                            ) : (
                                                <span style={commanStyles}>{shortHeader}</span>
                                            )}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {portOperation.map((operations, index) => {
                                const {
                                    operation = "",
                                    port = "",
                                    cargoDetails = {},
                                    index: operationIndex,
                                    dwf = 0,
                                    arrivalTime = "",
                                    departureTime = "",
                                } = operations;
                                const isBunkering = operation?.toLowerCase() === "bunkering";
                                const {
                                    reserve = "",
                                    bunkerSuppliedHSFO = 0,
                                    bunkerSuppliedLSFO = 0,
                                    bunkerSuppliedMGO = 0,
                                    paidBy = "Owner",
                                    bnkrFactor = 0,
                                    speedReduce = 0,
                                    speedFactor = 0,
                                } = cargoDetails || {};

                                const selectedArrivalBunker =
                                    selectedVessels?.portToPortOperationResultMap?.[operationIndex] || {};
                                const {
                                    arrivalHsfo = 0,
                                    arrivalLsfo = 0,
                                    arrivalMgo = 0,
                                } = selectedArrivalBunker;

                                const currentType = fuelType.replace("TYPE", "");
                                const currentHsfo = cargoDetails[`fuelPriceType${currentType}Hsfo`] || 0;
                                const currentLsFo = cargoDetails[`fuelPriceType${currentType}Lsfo`] || 0;
                                const currentMgo = cargoDetails[`fuelPriceType${currentType}Mgo`] || 0;

                                return (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <Tooltip title={<span className="text-xs">{operation}</span>} placement="top">
                                                <span style={commanStyles}>{operation}</span>
                                            </Tooltip>
                                        </TableCell>

                                        <TableCell>
                                            <Tooltip title={<span className="text-xs">{port}</span>} placement="top">
                                                <span style={commanStyles}>{port}</span>
                                            </Tooltip>
                                        </TableCell>

                                        <TableCell>
                                            <Tooltip title={<span className="text-xs">{dwf}</span>} placement="top">
                                                <input
                                                    onKeyDown={handleKeyDown}
                                                    type="number"
                                                    className="bunker-input"
                                                    value={dwf}
                                                    name="dwf"
                                                    onChange={(e) => onChangeMarginAllowance(e, index)}
                                                />
                                            </Tooltip>
                                        </TableCell>

                                        <TableCell>
                                            <Tooltip title={<span className="text-xs">{speedFactor}</span>} placement="top">
                                                <input
                                                    onKeyDown={handleKeyDown}
                                                    type="number"
                                                    className="bunker-input"
                                                    value={speedFactor}
                                                    name="speedFactor"
                                                    onChange={(e) => onChangeMarginAllowance(e, index)}
                                                />
                                            </Tooltip>
                                        </TableCell>

                                        <TableCell>
                                            <Tooltip title={<span className="text-xs">{speedReduce}</span>} placement="top">
                                                <input
                                                    onKeyDown={handleKeyDown}
                                                    type="number"
                                                    className="bunker-input"
                                                    value={speedReduce}
                                                    name="speedReduce"
                                                    onChange={(e) => onChangeMarginAllowance(e, index)}
                                                />
                                            </Tooltip>
                                        </TableCell>

                                        <TableCell>
                                            <Tooltip title={<span className="text-xs">{bnkrFactor}</span>} placement="top">
                                                <input
                                                    onKeyDown={handleKeyDown}
                                                    type="number"
                                                    className="bunker-input"
                                                    value={bnkrFactor}
                                                    name="bnkrFactor"
                                                    onChange={(e) => onChangeMarginAllowance(e, index)}
                                                />
                                            </Tooltip>
                                        </TableCell>

                                        <TableCell>
                                            <Tooltip
                                                title={<span className="text-xs">{arrivalTime ? moment(arrivalTime).format("DD-MM-yyyy HH:mm") : ""}</span>}
                                                placement="top"
                                            >
                                                <span style={commanStyles}>
                                                    {arrivalTime ? moment(arrivalTime).format("DD-MM-yyyy HH:mm") : ""}
                                                </span>
                                            </Tooltip>
                                        </TableCell>

                                        <TableCell>
                                            <Tooltip title={<span className="text-xs">{Number.isFinite(Number(arrivalHsfo)) ? fmt3(Number(arrivalHsfo)) : "0"}</span>} placement="top">
                                                <span style={commanStyles}>
                                                    {Number.isFinite(Number(arrivalHsfo)) ? fmt3(Number(arrivalHsfo)) : "0"}
                                                </span>
                                            </Tooltip>
                                        </TableCell>

                                        <TableCell>
                                            <Tooltip title={<span className="text-xs">{Number.isFinite(Number(arrivalLsfo)) ? fmt3(Number(arrivalLsfo)) : "0"}</span>} placement="top">
                                                <span style={commanStyles}>
                                                    {Number.isFinite(Number(arrivalLsfo)) ? fmt3(Number(arrivalLsfo)) : "0"}
                                                </span>
                                            </Tooltip>
                                        </TableCell>

                                        <TableCell>
                                            <Tooltip title={<span className="text-xs">{Number.isFinite(Number(arrivalMgo)) ? fmt3(Number(arrivalMgo)) : "0"}</span>} placement="top">
                                                <span style={commanStyles}>
                                                    {Number.isFinite(Number(arrivalMgo)) ? fmt3(Number(arrivalMgo)) : "0"}
                                                </span>
                                            </Tooltip>
                                        </TableCell>

                                        <TableCell>
                                            <input
                                                onKeyDown={handleKeyDown}
                                                type="number"
                                                value={bunkerSuppliedHSFO}
                                                name="bunkerSuppliedHSFO"
                                                className="bunker-input"
                                                disabled={index === 0}
                                                onChange={(e) => onChangePortOperations(index, e, true)}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <input
                                                onKeyDown={handleKeyDown}
                                                type="number"
                                                value={bunkerSuppliedLSFO}
                                                name="bunkerSuppliedLSFO"
                                                className="bunker-input"
                                                disabled={index === 0}
                                                onChange={(e) => onChangePortOperations(index, e, true)}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <input
                                                onKeyDown={handleKeyDown}
                                                type="number"
                                                value={bunkerSuppliedMGO}
                                                name="bunkerSuppliedMGO"
                                                className="bunker-input"
                                                disabled={index === 0}
                                                onChange={(e) => onChangePortOperations(index, e, true)}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <Tooltip
                                                title={<span className="text-xs">{Number(bunkerSuppliedHSFO) + Number(bunkerSuppliedLSFO) + Number(bunkerSuppliedMGO)}</span>}
                                                placement="top"
                                            >
                                                <span style={commanStyles}>
                                                    {Number(bunkerSuppliedHSFO) + Number(bunkerSuppliedLSFO) + Number(bunkerSuppliedMGO)}
                                                </span>
                                            </Tooltip>
                                        </TableCell>

                                        <TableCell>
                                            <select
                                                name="reserve"
                                                className="bunker-select"
                                                value={reserve}
                                                onChange={(e) => onChangePortOperations(index, e, true)}
                                            >
                                                <option value="Reserve">Reserve</option>
                                                <option value="Supply">Supply</option>
                                            </select>
                                        </TableCell>

                                        <TableCell>
                                            <select
                                                name="paidBy"
                                                className="bunker-select"
                                                value={paidBy}
                                                onChange={(e) => onChangePortOperations(index, e, true)}
                                            >
                                                <option value="Operator">External</option>
                                                <option value="Owner">Internal</option>
                                            </select>
                                        </TableCell>

                                        <TableCell>
                                            <input
                                                onKeyDown={handleKeyDown}
                                                type="number"
                                                value={currentHsfo}
                                                name={`fuelPriceType${currentType}Hsfo`}
                                                className="bunker-input"
                                                disabled={!(syncBunker && index !== 0)}
                                                onChange={(e) => onChangeBunkerScrubber(index, e)}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <input
                                                onKeyDown={handleKeyDown}
                                                type="number"
                                                value={currentLsFo}
                                                name={`fuelPriceType${currentType}Lsfo`}
                                                className="bunker-input"
                                                disabled={!(syncBunker && index !== 0)}
                                                onChange={(e) => onChangeBunkerScrubber(index, e)}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <input
                                                onKeyDown={handleKeyDown}
                                                type="number"
                                                value={currentMgo}
                                                name={`fuelPriceType${currentType}Mgo`}
                                                className="bunker-input"
                                                disabled={!(syncBunker && index !== 0)}
                                                onChange={(e) => onChangeBunkerScrubber(index, e)}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <Tooltip
                                                title={<span className="text-xs">{departureTime ? moment(departureTime).format("DD-MM-yyyy HH:mm") : ""}</span>}
                                                placement="top"
                                            >
                                                <span style={commanStyles}>
                                                    {departureTime ? moment(departureTime).format("DD-MM-yyyy HH:mm") : ""}
                                                </span>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    );
}

export default BunkerSupplyMarginAllowance;